import { DeptoI } from "./departamento.interface";
import { EstadoEntiI } from "./estadoEntidad.interface";
import { MuniI } from "./municipio.interface";
import { OperacionI } from "./operacionEsta.interface";
import { SuperI } from "./superintendecia.interface";
import { TipoEntidadI } from "./tipoEntidad.interface";

export class fuenteI{
  id : BigInteger;
  nit : String;
  codSuper : String;
  codTipoEntidad : String;
  codEnti : String;
  nombEntidad : String;
  depto : String;
  muni : String;
  direccion : String;
  idEstado : EstadoEntiI;
  operacion : OperacionI;
  telefono : String;
  email : String;
  nombresp : String;
  cargoresp : String;
  telresp : String;
  codigoFinanciador : any;
  emailInfo : any;
  nombrespInfo : any;
  cargorespInfo : any;
  telrespInfo : any;
}

